import filter from "lodash/filter";
import groupBy from "lodash/groupBy";
import map from "lodash/map";
import sum from "lodash/sum";

import ChatActions from "../../actions/ChatActions";
import alt from "../../alt/ChatAlt";

export class NotificationStore {
    constructor() {
        this.bindActions(ChatActions);
        this.bindListeners({
            onFail: [ChatActions.authFail, ChatActions.resetAuth, ChatActions.loadNotificationsFail],
        });

        this.allOpenQuestionsId = [];
        this.isLoading = true;
        this.notifications = [];
        this.unansweredOpenQuestionsId = [];
    }

    onFail() {
        this.setState({ isLoading: false });
    }

    onLoadNotifications() {
        this.setState({ isLoading: true });
    }

    onLoadNotificationsSuccess({ openQuestions, notifications }) {
        this.setState({
            allOpenQuestionsId: openQuestions.all,
            isLoading: false,
            notifications,
            unansweredOpenQuestionsId: openQuestions.unanswered,
        });
    }

    static getNotificationsByType(type) {
        return filter(this.getState().notifications, { type });
    }

    static getUnreadMessagesCount() {
        const unreadResponseNotifications = this.getNotificationsByType("UnreadResponse");
        const unreadMessages = map(unreadResponseNotifications, "data.unreadMessages");

        return sum(unreadMessages);
    }

    static getNotificationsGroupedByQuestion() {
        const unreadResponseNotifications = this.getNotificationsByType("UnreadResponse");

        return groupBy(map(unreadResponseNotifications, "data"), "questionUuid");
    }

    static getNotificationsGroupedByAvatar() {
        const unreadResponseNotifications = this.getNotificationsByType("UnreadResponse");

        return groupBy(map(unreadResponseNotifications, "data"), "avatarSrc");
    }
}

export default alt.createStore(NotificationStore, "NotificationStore");
